"use client";
import {
  ActionIcon,
  Box,
  Container,
  Group,
  Text,
  Anchor,
  Flex,
} from "@mantine/core";
import LogoLetter from "src/components/Icons/LogoLetter";
import FacebookIcon from "@/components/Icons/FacebookIcon";
import Mail from "@/components/Icons/Mail";
import InstaIcon from "@/components/Icons/InstaIcon";

const data = [
  {
    title: "Search",
    links: [
      { label: "Disc Search", link: "/disc-search" },
      { label: "Advanced Finder", link: "/advanced-disc-finder" },
      { label: "Disc Brands", link: "/disc-brands" },
    ],
  },
  {
    title: "Features",
    links: [
      { label: "Price Alerts", link: "/disc-golf-price-alerts" },
      { label: "Flight Charts", link: "/disc-golf-flight-chart-playground" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy", link: "/privacy" },
      { label: "Terms", link: "/terms" },
    ],
  },
];

export default function Footer() {
  const groups = data.map((group) => {
    const links = group.links.map((link, index) => (
      <Anchor
        key={index}
        c="dimmed"
        component="a"
        href={link.link}
        size="sm"
        style={{ display: "block", marginTop: "8px" }}
      >
        {link.label}
      </Anchor>
    ));

    return (
      <Box key={group.title}>
        <Text fw={700} size="sm" mb="xs">
          {group.title}
        </Text>
        {links}
      </Box>
    );
  });

  return (
    <Box component="footer" mt={120} bg="var(--colors-bg-card)">
      <Container size="lg" py="xl">
        <Group align="flex-start" justify="space-between" wrap="wrap">
          <Box style={{ maxWidth: 250 }}>
            <Flex align="flex-start" direction="column">
              <Box>
                <LogoLetter />
              </Box>
              <Text size="xs" c="dimmed" mt="md">
                Ultimate disc golf search engine and price comparison platform.
                Search 200,000+ in-stock discs from all major retailers.
              </Text>
            </Flex>
          </Box>
          <Group gap={50} justify="flex-start" align="flex-start">
            {groups}
          </Group>
        </Group>
      </Container>

      <Box style={{ borderTop: "1px solid var(--mantine-color-gray-3)" }}>
        <Container size="lg" py="md">
          <Group justify="space-between" wrap="wrap">
            <Text c="dimmed" size="sm">
              © 2025 Stacks on Stacks LLC. All rights reserved.
            </Text>

            <Group gap={0} justify="flex-end" wrap="nowrap">
              <ActionIcon
                component="a"
                size="lg"
                color="gray"
                variant="subtle"
                href="https://www.facebook.com/people/Stacks-on-Stacks/100089439401540/"
                aria-label="Facebook Link"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FacebookIcon />
              </ActionIcon>
              <ActionIcon
                component="a"
                size="lg"
                color="gray"
                variant="subtle"
                href="https://www.instagram.com/stacksonstacksdg/"
                aria-label="Instagram Link"
                rel="noopener noreferrer"
                target="_blank"
              >
                <InstaIcon />
              </ActionIcon>
              <ActionIcon
                component="a"
                size="lg"
                color="gray"
                variant="subtle"
                href="mailto:info@stacks-on-stacks.com"
                aria-label="Mail Link"
              >
                <Mail />
              </ActionIcon>
            </Group>
          </Group>
        </Container>
      </Box>
    </Box>
  );
}
